module.exports = __webpack_public_path__ + "static/media/black-widow-win.16b0fde7.png";